import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DefaultPageComponent } from './components/default-page/default-page.component';
import { GenericModule } from 'common';


@NgModule({
  imports: [
    CommonModule, GenericModule
  ],
  declarations: [DefaultPageComponent]
})
export class InteractionModule { }
